<div class="select is-small mr-2" [class.is-loading]="loading">
  <select [(ngModel)]="value" [class]="style" (change)="SelectItem()" (ngModelChange)="modelChange($event)">
    <option value="">{{label}}</option>
    <option *ngFor="let item of items" [value]="item.value" [class.disabled]="item.disable" [title]="item.disable ? 'Center is not Active':''">
      {{ withIcon ? (item.disable ? '&#10006;&nbsp;-&nbsp;':'&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;') : ''}}{{item.label}}
    </option>
  </select>
</div>
